'use client';

import {
  Breakpoint,
  Button,
  CheckboxCard,
  CheckboxGroup,
  DropdownSelect,
  SheetBody,
  SheetClose,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetHeading,
  SheetRoot,
  SheetTrigger,
  Stack,
} from '@pie/amber';
import { useState } from 'react';

type Props = {
  onChangeAction: (next: string[]) => void;
  options: {
    label: string;
    value: string;
  }[];
  value: string[];
};

const MobileStatusFilterSheet = ({ onChangeAction, options, value }: Props) => {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState<string[]>(value);

  const handleOpenChange = (next: boolean) => {
    // Re-seed the draft from the committed value each time the sheet opens.
    if (next) setDraft(value);
    setOpen(next);
  };

  const handleApply = () => {
    onChangeAction(draft);
    setOpen(false);
  };

  return (
    <SheetRoot onOpenChange={handleOpenChange} open={open} side="bottom">
      <SheetTrigger>
        {/* TODO: this should be a Button, but there is no variant that matches the DropdownSelect */}
        <DropdownSelect
          className="max-w-[12rem]"
          label="Status"
          labelHidden
          multiple
          options={options}
          placeholder="Status"
          value={value}
        />
      </SheetTrigger>
      <SheetContent>
        <SheetHeader>
          <SheetHeading>Filter by Policy Status</SheetHeading>
          <SheetClose label="Close filter options" />
        </SheetHeader>
        <SheetBody>
          <CheckboxGroup legend="Status" onValueChange={setDraft} value={draft}>
            <Stack gap="xs">
              {options.map((option) => (
                <CheckboxCard key={option.value} label={option.label} value={option.value} />
              ))}
            </Stack>
          </CheckboxGroup>
        </SheetBody>
        <SheetFooter>
          <Button emphasis="heavy" fluid onClick={handleApply} size="lg" tone="accent">
            Apply
          </Button>
        </SheetFooter>
      </SheetContent>
    </SheetRoot>
  );
};

export const StatusFilter = ({ onChangeAction, options, value }: Props) => (
  <Breakpoint
    above="sm"
    fallback={
      <MobileStatusFilterSheet onChangeAction={onChangeAction} options={options} value={value} />
    }
  >
    <DropdownSelect
      align="end"
      className="max-w-[12rem]"
      label="Status"
      labelHidden
      multiple
      onValueChange={onChangeAction}
      options={options}
      placeholder="Status"
      value={value}
    />
  </Breakpoint>
);
